import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
// import "../../../node_modules/datatables.net-dt/css/jquery.dataTables.min.css";
// import "../../../node_modules/datatables.net-responsive-dt/css/responsive.dataTables.min.css";
import $ from "jquery";
import "datatables.net";
import "datatables.net-responsive";
import { showSuccess, showError } from "toast/toast";
import DataTable from "components/DataTable";
import PaginationControls from "components/PaginationControls";
import React, { useEffect, useMemo, useState, useRef, KeyboardEvent, ChangeEvent } from "react";
import Select, { components } from "react-select";
import { RemovalStatusBadge } from "components/Removalstatus";
import { StatusBadge } from "components/Productlocationstatus";
import TablePaginationControls from "components/TableandmobilePaginationcontrol"
import { DesktopTableParts, MobileCardsOnly } from "components/TableandMobilecomponent";
import {
  DesktopTableLoader,
  MobileCardsLoader,
  DataTableStatus,
} from "components/DataTableLoader";
import { ViewIconButton, EditIconButton, DeleteIconButton } from "components/DatatablesActionIcons";
import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  flexRender,
  createColumnHelper,
} from "@tanstack/react-table";

import {
  ExportAsExcel,
} from "@siamf/react-export";
import { fetchParentHierarchy } from "utils/userDataFetcher";
import { getAuthCookie } from "../../utils/authCookies";
import { useModuleActionPermissions } from "hooks/useModuleActionPermissions";
import { MODULE_PERMISSION_NAMES } from "utils/moduleActionPermissions";
import { formatPaymentMethodLabel } from "../../utils/paymentMethodLabel";

const DATE_OPTIONS = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Last 15 Days", value: "last_15_days" },
  { label: "Last 30 Days", value: "last_30_days" },
  { label: "Custom", value: "custom" },
];

/** Placeholder option — full list is built in the component. */
const EMPTY_ORDER_STATUS_OPTION = { value: "", label: "Order Status" };

const PAYMENT_STATUS_OPTIONS = [
  { value: "", label: "Payment Status" },
  { value: "Paid", label: "Paid" },
  { value: "Partial Payment", label: "Partial Payment" },
  { value: "Pending", label: "Pending" },
  { value: "Overdue", label: "Overdue" }
];

const INVOICE_STATUS_OPTIONS = [
  { value: "", label: "Invoice Status" },
  { value: "yes", label: "Invoice Sent" },
  { value: "no", label: "Not Sent" },
];

const PRIORITY_OPTIONS = [
  { value: "", label: "Priority" },
  { value: "1", label: "High" },
  { value: "2", label: "Medium" },
  { value: "3", label: "Low" }
];


type Category = {
  id: string;
  name: string;
  image: string;
  status: string;
};

export type RemovalOrders = {
  _id: string;                     // Unique id (map from order_id)
  order_id: string;                // Order ID from API
  created_date: string;            // Created date
  brokerage_firm: string;
  office: string;
  agent: string;
  installer: string;
  installation_date: string;
  payment_status: string;
  payment_method: string;
  status: number;
  product_location_status: string;
  priority: number;
};

// interface ExportRow {
//   "Company Name": string;
//   "First Name": string;
//   "Last Name": string;
//   "Phone": string;
//   "Email": string;
//   "License Status": string;
//   "Company Status": string;
// }

const PRIORITY_LABELS: { [key: number]: string } = {
  1: "High",
  2: "Medium",
  3: "Low",
};

const DropdownIndicator = (props: any) => {
  if (props.selectProps.isDisabled) return null;
  return (
    <components.DropdownIndicator {...props}>
      <i className="ri-arrow-down-s-line fs-5" style={{ color: "#6c757d" }} />
    </components.DropdownIndicator>
  );
};

const customSelectStyles = {
  indicatorsContainer: (p: any, s: any) => ({ ...p, display: s.isDisabled ? "none" : "flex" }),
  dropdownIndicator: (p: any, s: any) => ({ ...p, display: s.isDisabled ? "none" : "flex" }),
  indicatorSeparator: () => ({ display: "none" }),
  control: (p: any, s: any) => ({
    ...p,
    backgroundColor: s.isDisabled ? "#f2f2f2" : p.backgroundColor,
    cursor: s.isDisabled ? "not-allowed" : "pointer",
    opacity: 1,
  }),
  singleValue: (p: any, s: any) => ({ ...p, color: s.isDisabled ? "#000" : p.color }),
  valueContainer: (p: any, s: any) => ({ ...p, color: s.isDisabled ? "#000" : p.color }),
  input: (p: any, s: any) => ({ ...p, color: s.isDisabled ? "#000" : p.color, WebkitTextFillColor: s.isDisabled ? "#000" : undefined }),
  placeholder: (p: any, s: any) => ({ ...p, color: s.isDisabled ? "#000" : p.color }),
  menu: (provided: any) => ({ ...provided, zIndex: 9999, position: "absolute", top: "100%", left: 0, right: 0 }),
  menuList: (provided: any) => ({ ...provided, maxHeight: "220px" }),
};

const columnHelper = createColumnHelper<RemovalOrders>();


const SignageRemovalRequests = () => {
  const [error, setError] = useState<string>("");
  const [removal, setRemoval] = useState<RemovalOrders[]>([]);
  const [filteredremoval, setFilteredRemoval] = useState<RemovalOrders[]>([]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState<string | null>(null);
  const [rowCount, setRowCount] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const [searchInput, setSearchInput] = useState<string>(globalFilter ?? "");
  const searchInputRef = useRef<HTMLInputElement>(null);
  const fetchRequestIdRef = useRef(0);
  const hasLoadedDataRef = useRef(false);
  // const [exportRows, setExportRows] = useState<ExportRow[]>([]);
  const token = getAuthCookie("sessionToken");
  const userId = getAuthCookie("userId");
  const userName = getAuthCookie("userName");
  const [parentSignageId, setParentSignageId] = useState<string | null>(null);
  const [parentSignageName, setParentSignageName] = useState<string | null>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const isSignageTeammember = location.pathname.includes('/signageteammember');
  const baseRoute = isSignageTeammember ? '/signageteammember' : '/signage';

  const { canCreate, canView, canEdit, canDelete } = useModuleActionPermissions(
    MODULE_PERMISSION_NAMES.removal_orders
  );

  function getRemovalWorkOrderId(order: RemovalOrders): string {
    return String((order as any)?._id ?? (order as any)?.id ?? (order as any)?.order_id ?? "");
  }

  const signageId = (isSignageTeammember && parentSignageId) ? parentSignageId : userId;
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [datePreset, setDatePreset] = useState(DATE_OPTIONS[3]);
  const [customFrom, setCustomFrom] = useState("");
  const [customTo, setCustomTo] = useState("");

  const { minDate, maxDate } = useMemo(() => {
    const now = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(now.getMonth() - 6);
    return {
      minDate: sixMonthsAgo.toISOString().split("T")[0],
      maxDate: now.toISOString().split("T")[0],
    };
  }, []);

  useEffect(() => {
    if (datePreset.value === "custom") {
      if (customFrom && customFrom < minDate) setCustomFrom("");
      if (customTo && customTo < minDate) setCustomTo("");
      if (customFrom && customFrom > maxDate) setCustomFrom("");
      if (customTo && customTo > maxDate) setCustomTo("");
    }
  }, [datePreset.value, minDate, maxDate]);

  useEffect(() => {
    if (isSignageTeammember && token) {
      fetchParentHierarchy(token).then((res) => {
        if (res) {
          setParentSignageId(res.parentSignageId);
          setParentSignageName(res.parentSignageName);
        }
      });
    }
  }, [isSignageTeammember, token]);

  const [orderStatusFilter, setOrderStatusFilter] = useState(EMPTY_ORDER_STATUS_OPTION);
  const [invoiceSentFilter, setInvoiceSentFilter] = useState(INVOICE_STATUS_OPTIONS[0]);
  const [paymentStatusFilter, setPaymentStatusFilter] = useState(PAYMENT_STATUS_OPTIONS[0]);
  const [priorityFilter, setPriorityFilter] = useState(PRIORITY_OPTIONS[0]);
  const [exporting, setExporting] = useState(false);

  const orderStatusOptions = useMemo(
    () => [
      EMPTY_ORDER_STATUS_OPTION,
      { value: "100", label: "Draft" },
      { value: "200", label: "Finalized" },
      { value: "300", label: "Scheduled" },
      { value: "400", label: "In Progress" },
      { value: "500", label: "Completed" },
      { value: "600", label: "Closed" },
      { value: "700", label: "Cancelled" },
      { value: "800", label: "Void" },
    ],
    []
  );

  useEffect(() => {
    setOrderStatusFilter((prev) => {
      if (prev.value !== "100") return prev;
      const next = orderStatusOptions.find((o) => o.value === "100");
      return next && next.label !== prev.label ? next : prev;
    });
  }, [orderStatusOptions]);

  const handleExportCsv = async () => {
    if (!signageId || !token) return;
    try {
      setExporting(true);
      const url = `${process.env.REACT_APP_API_URL}/removal_orders/signage/${signageId}/export/csv`;
      const body = {
        search: globalFilter ?? "",
        invoice_sent: invoiceSentFilter?.value ?? "",
        status: orderStatusFilter?.value ? [Number(orderStatusFilter.value)] : [],
        payment_status: paymentStatusFilter?.value ?? "",
        priority: priorityFilter?.value ? [Number(priorityFilter.value)] : [],
        agent_id: null,
        office_id: null,
        signage_id: null,
        date_range: {
          type: datePreset?.value ?? "",
          from: datePreset?.value === "custom" ? customFrom : "",
          to: datePreset?.value === "custom" ? customTo : "",
        },
        page: 1,
        limit: rowCount || 10000,
        sort_by: "created_at",
        sort_dir: "desc",
      };
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error("Export failed");
      const blob = await res.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "removal-requests.csv";
      link.click();
      URL.revokeObjectURL(link.href);
      showSuccess("Export downloaded");
    } catch (err: any) {
      showError(err?.message || "Failed to export");
    } finally {
      setExporting(false);
    }
  };

  useEffect(() => {
    if (isSignageTeammember && !parentSignageId) return;
    if (!signageId || !token) return;

    const fetchAgents = async () => {
      const requestId = ++fetchRequestIdRef.current;
      const showInitialLoader = !hasLoadedDataRef.current;
      if (showInitialLoader) setLoading(true);
      const hasSearch = Boolean(globalFilter?.trim());
      const dateRange = hasSearch
        ? { type: "", from: "", to: "" }
        : {
            type: datePreset.value,
            from: datePreset.value === "custom" ? customFrom : "",
            to: datePreset.value === "custom" ? customTo : "",
          };
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/removal_orders/signage/${signageId}/datatable`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              page: pagination.pageIndex + 1,
              limit: pagination.pageSize,
              search: globalFilter,
              invoice_sent: invoiceSentFilter.value || "",
              status: orderStatusFilter.value ? [Number(orderStatusFilter.value)] : undefined,
              payment_status: paymentStatusFilter.value || undefined,
              priority: priorityFilter.value ? [Number(priorityFilter.value)] : undefined,
              agent_id: null,
              office_id: null,
              date_range: dateRange,
              sort_by: "created_at",
              sort_dir: "desc",
            }),
          }
        );

        if (!response.ok) {
          showError("Access denied. You don’t have view permission for Removal requests.");
        }

        const result = await response.json();
        if (requestId !== fetchRequestIdRef.current) return;
        console.log(result, "result");
        setRowCount(result.total);

        const removal = result?.data ?? [];
        console.log("removal", result);
        if (Array.isArray(removal)) {
          setRemoval(removal);
          setFilteredRemoval(removal);
          hasLoadedDataRef.current = true;
        } else {
          throw new Error("Unexpected response format for agents");
        }

      } catch (err) {
        if (requestId !== fetchRequestIdRef.current) return;
        // setError(
        //   err instanceof Error ? err.message : "An unknown error occurred"
        // );
        showError("Access denied. You don’t have view permission for Removal requests.");
        
      } finally {
        if (requestId === fetchRequestIdRef.current) {
          setLoading(false);
          // Maintain cursor focus in search input after loading
          if (searchInputRef.current) {
            searchInputRef.current.focus();
          }
        }
      }
    };

    fetchAgents();
  }, [
    token,
    signageId,
    isSignageTeammember,
    parentSignageId,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    deleting,
  ]);

  // useEffect(() => {
  //   const rows: ExportRow[] = filteredremoval.map(firm => ({
  //     "Company Name": firm?.firmDetails?.companyName,
  //     "First Name": firm?.firstName || '',
  //     "Last Name": firm?.lastName || '',
  //     "Phone": firm?.firmDetails?.address?.phone || '',
  //     "Email": firm?.email || '',
  //     "License Status": firm?.LicenseActive ? 'Active' : 'Inactive',
  //     "Company Status": firm.status,
  //   }));

  //   setExportRows(rows);
  // }, [filteredFirms]);
  // useEffect(() => {
  //   const fetchRemovalRequests = async () => {
  //     try {
  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_URL}/removal_orders/signage/${userId}`,
  //         {
  //           method: "GET",
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //       const data = await response.json();

  //       if (!response.ok) {
  //         showError(data?.error || "Failed to fetch removal requests.");
  //         return;
  //       }

  //       setRemovalRequests(Array.isArray(data) ? data : []);
  //     } catch (err) {
  //       showError(
  //         err instanceof Error ? err.message : "An unknown error occurred."
  //       );
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchRemovalRequests();
  // }, []);


  // useEffect(() => {
  //   // Initialize DataTable when categories change
  //   const table = $("#removalRequestsTable").DataTable({
  //     responsive: true,
  //     destroy: true, // Ensure DataTable re-initializes properly
  //     // columnDefs: [
  //     //   { orderable: false, targets: [0, 4] }, // Disable sorting for specific columns
  //     // ],
  //     lengthChange: false,
  //     ordering: false,
  //   });

  //   return () => {
  //     table.destroy(); // Clean up on component unmount
  //   };
  // }, [removalRequests]);

  const handleDelete = async (orderId: string) => {
    setDeleting(orderId);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/removal_orders/${orderId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        showError(data?.error || "Failed to delete removal request.");
        return;
      }

      showSuccess("Removal request deleted successfully!");
      // setRemovalRequests((prev) => prev.filter((order) => order._id !== orderId));
    } catch (err) {
      showError(
        err instanceof Error ? err.message : "An unknown error occurred."
      );
    } finally {
      setDeleting(null);
    }
  };

  const columns = useMemo(() => [
    // columnHelper.display({
    //   id: "serial",
    //   header: () => <div className="th-text S-No">S.No.</div>,
    //   cell: (info) => (
    //     <div className="th-text S-No">
    //       {pagination.pageIndex * pagination.pageSize + info.row.index + 1}
    //     </div>
    //   ),
    // }),
    columnHelper.accessor("order_id", {
      id: "order_number",
      header: () => <div className="th-text S-No">Order ID</div>,
      cell: (info) => {
        const row = info.row.original;
        // pick whichever your data uses:
        const orderId =
          (row as any).id ?? (row as any)._id ?? (row as any).order_id;

        return (
          <Link
            to={`${baseRoute}/jobs/removalWorkorder/${info.row.original._id}`}
            className="text-sm S-No order-link-1"
          >
            {info.getValue() ?? ""}
          </Link>
        );
      },
      // filterFn: fuzzyTextFilter,
      enableGlobalFilter: true,
    }),
    // columnHelper.accessor("order_id", {
    //   header: () => <div className="th-text S-No">Order ID</div>,
    //   cell: (info) => <div className="text-sm order-link-1 S-No">{info.getValue()}</div>,
    // }),
    columnHelper.accessor("created_date", {
      header: () => <div className="th-text">Created Date</div>,
      cell: (info) => (
        <div className="text-sm">
          {info.getValue() ? new Date(info.getValue()).toLocaleDateString() : "—"}
        </div>
      ),
    }),
    columnHelper.accessor("brokerage_firm", {
      header: () => <div className="th-text">Brokerage firm</div>,
      cell: (info) => <div className="text-sm">{info.getValue() || "—"}</div>,
    }),
    columnHelper.accessor("office", {
      header: () => <div className="th-text">Office</div>,
      cell: (info) => <div className="text-sm">{info.getValue() || "—"}</div>,
    }),
    columnHelper.accessor("agent", {
      header: () => <div className="th-text">Agent</div>,
      cell: (info) => <div className="text-sm">{info.getValue() || "—"}</div>,
    }),
    columnHelper.accessor("installer", {
      header: () => <div className="th-text">Installer</div>,
      cell: (info) => <div className="text-sm">{info.getValue() || "—"}</div>,
    }),
    columnHelper.accessor("installation_date", {
      header: () => <div className="th-text">Removal Date</div>,
      cell: (info) => {
        const removalDate = info.getValue();
        if (!removalDate || String(removalDate).startsWith("0001-01-01")) {
          return <div className="text-sm">--</div>;
        }
        return (
          <div className="text-sm">
            {new Date(removalDate).toLocaleDateString()}
          </div>
        );
      },
    }),
    columnHelper.accessor("payment_status", {
      header: () => <div className="th-text">Payment Status</div>,
      cell: info => (
        <div className="text-sm">
          <RemovalStatusBadge value={info.getValue() as string} type="payment" />
        </div>
      ),
    }),
    columnHelper.accessor(
      (row) => formatPaymentMethodLabel(row.payment_method),
      {
        id: "payment_method",
        header: () => <div className="th-text">Payment Method</div>,
        cell: info => <div className="text-sm">{info.getValue()}</div>,
        enableGlobalFilter: true,
      }
    ),

    // Order Status column
    columnHelper.accessor("status", {
      header: () => <div className="th-text">Status</div>,
      cell: info => {
        const statusVal = info.getValue() as number;
        return (
          <div className="text-sm">
            <RemovalStatusBadge
              type="order"
              value={
                statusVal
              }
            />
          </div>
        );
      },
    }),
    // columnHelper.accessor("payment_status", {
    //   header: () => <div className="th-text">Payment Status</div>,
    //   cell: (info) => <div className="th-text">{info.getValue() || "—"}</div>,
    // }),
    // columnHelper.accessor("status", {
    //   header: () => <div className="th-text">Status</div>,
    //   cell: (info) => {
    //     const status = info.getValue();
    //     const label =
    //       status === 100 ? "Draft" :
    //         status === 200 ? "Finalized" :
    //           status === 300 ? "Scheduled" :
    //             status === 400 ? "In Progress" :
    //               status === 500 ? "Completed" :
    //                 status === 600 ? "Canceled" : "Unknown";
    //     return <div className="th-text">{label}</div>;
    //   },
    // }),
    columnHelper.accessor("product_location_status", {
      header: () => <div className="th-text">Handover Method</div>,
      cell: (info) => (
        <div className="text-sm">
          <StatusBadge status={info.getValue() || "-"} />
        </div>
      ),
    }),

    // columnHelper.accessor("priority", {
    //   header: () => <div className="th-text">Priority</div>,
    //   cell: (info) => <div className="th-text">{info.getValue() || "—"}</div>,
    // }),

    columnHelper.accessor("priority", {
      header: () => <div className="th-text">Priority</div>,
      cell: (info) => {
        const val = info.getValue() as number | undefined | null;
        const label = val ? PRIORITY_LABELS[val] : undefined;

        // Render badge component with label (or fallback)
        return (
          <div className="text-sm">
            {label ? (
              <RemovalStatusBadge value={label} type="priority" />
            ) : (
              "—"
            )}
          </div>
        );
      },
    }),

    // Payment Due Date (last payment_info object has the latest due_date)
    columnHelper.accessor(
      (row) => {
        const paymentStatus = String((row as any)?.payment_status || "").trim().toLowerCase();
        if (paymentStatus === "paid") return "--";

        const paymentInfo = (row as any)?.payment_info;
        const last = Array.isArray(paymentInfo) && paymentInfo.length > 0 ? paymentInfo[paymentInfo.length - 1] : null;
        const dueDate = last?.due_date;
        if (!dueDate || String(dueDate).startsWith("0001-01-01")) return "--";
        const d = new Date(dueDate);
        return isNaN(d.getTime())
          ? "--"
          : d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
      },
      {
        id: "payment_due_date",
        header: () => <div className="th-text">Payment Due Date</div>,
        cell: (info) => <div className="text-sm">{info.getValue()}</div>,
        enableGlobalFilter: false,
      }
    ),

    columnHelper.accessor(
      (row) => {
        const raw = String((row as any)?.invoice_sent ?? "").trim().toLowerCase();
        return raw === "yes" || raw === "true" || raw === "1";
      },
      {
        id: "invoice_sent",
        header: () => <div className="th-text">Invoice Sent</div>,
        cell: (info) => {
          const sent = info.getValue<boolean>();
          return (
            <div className="text-sm">
              {sent ? (
                <input
                  type="checkbox"
                  checked
                  disabled
                  readOnly
                  className="form-check-input bg-success border-success"
                  style={{
                    width: "1.2rem",
                    height: "1.2rem",
                    cursor: "not-allowed",
                  }}
                  title="Yes"
                />
              ) : (
                "-"
              )}
            </div>
          );
        },
        enableGlobalFilter: false,
      }
    ),

    columnHelper.display({
      id: "actions",
      header: () => <div className="th-text">Actions</div>,
      cell: (info) => (
        <div className="d-flex  align-items-center gap-2">
          {canView && (
            <ViewIconButton
              title="View"
              to={`${baseRoute}/jobs/removalWorkorder/${info.row.original._id}`}
              state={{ type: "View" }}
            />
          )}
          {
            info.row.original.status < 400 &&
            canEdit && (
              <EditIconButton
                className="icon-square me-3"
                title="Edit"
                to={`${baseRoute}/jobs/removalWorkorder/${info.row.original._id}`}
                state={{ type: "Edit" }}
              />
            )
          }

        </div>
      ),
    }),
  ], [pagination, baseRoute, canView, canEdit]);


  const table = useReactTable({
    data: removal,
    columns,
    pageCount: Math.ceil(rowCount / pagination.pageSize), // Or whatever total count if server-side
    state: {
      pagination,
      // Add globalFilter if needed
    },
    manualPagination: true,
    getCoreRowModel: getCoreRowModel(),
    onPaginationChange: setPagination,
  });

  const showTableLoader = loading && removal.length === 0;

  return (
    <div className="content">
      <div className="d-flex justify-content-between align-items-center pb-3 mb-2 py-3">
        <h4 className="mb-0 fw-bold"></h4>
        <div className="d-flex gap-3 align-items-center">
          {canCreate && (
            <Link to={`${baseRoute}/jobs/addRemovalRequest`} className="btn btn-primary  table-addbutton">
            + Add Removal
          </Link>
          )}
        </div>
      </div>

      <div className="po-header mb-4">
        {/* TOP ROW */}
        <div className="po-top d-flex justify-content-between align-items-start align-items-md-center flex-wrap gap-2">
          <div className="po-title-wrap me-2">
            <h4 className="mb-1 po-title">Removal Requests</h4>
            {/* <div className="po-subtitle">Manage incoming products from suppliers and brokerages</div> */}
          </div>

          {/* tools block (search + buttons) */}
          <div className="po-tools d-flex align-items-center flex-wrap gap-2 ms-auto">
            {/* Search */}
            <div className="input-group po-search ">
              <span className="input-group-text">
                <i className="ri-search-line" />
              </span>
              <input
                ref={searchInputRef}
                type="text"
                id="searchInput"
                name="searchInput"
                className="form-control" 
                placeholder="Search by Product Name, SKU, Brokerages…"
                value={searchInput}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchInput(e.target.value)}
                onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
                  if (e.key === "Enter") {
                    setPagination((prev) => ({ ...prev, pageIndex: 0 })); // :white_check_mark: Reset to page 1
                    setGlobalFilter(searchInput);
                  }
                }}
                autoComplete="off"
              />
            </div>

            {/* Filters toggle */}
            <button
              type="button"
              className={` po-filter-btn d-inline-flex align-items-center ${filtersOpen ? "active" : ""}`}
              onClick={() => setFiltersOpen(v => !v)}
              aria-expanded={filtersOpen}
              aria-controls="incoming-filters"
            >
              <i className="ri-filter-3-line me-2" />
              <span>Filters</span>
              <i className={`ri-arrow-down-s-line ms-1 ${filtersOpen ? "rotate-180" : ""}`} />
            </button>

            {/* Export to Excel */}
            <button
              type="button"
              className="export-button"
              onClick={handleExportCsv}
              disabled={exporting}
            >
              <i className="ri-file-excel-2-line me-2" />
              <span>{exporting ? "Exporting…" : "Export to Excel"}</span>
            </button>

            {/* Export */}
            {/* <ExportAsExcel
              data={removal}
              headers={[
                "Order ID",
                "Created Date",
                "Brokerage Firm",
                "Office",
                "Agent",
                "Installer",
                "Installation Date",
                "Payment Status",
                "Status",
                "Handover Method",
                "Priority"
              ]}
              fileName="RemovalRequests"
            >
              {(props) => (
                <button {...props} className="export-button">
                  <i className="ri-file-excel-2-line me-2" />
                  Export to Excel
                </button>
              )}
            </ExportAsExcel> */}
          </div>
        </div>

        <div id="incoming-filters" className={`po-filters ${filtersOpen ? "show" : ""}`}>
          <div className="po-filters-bar d-flex">
            <div className="row g-2 g-md-3 align-items-end justify-content-md-end ms-md-auto w-100 w-md-auto">

              {/* Date Range */}
              <div className="col-12 col-md-auto">
                <label className="form-label mb-1 label-1">Date Range</label>
                <div className="po-rs min-220">
                  <Select
                    classNamePrefix="rs"
                    options={DATE_OPTIONS}
                    value={datePreset}
                    onChange={(val) => val && setDatePreset(val)}
                    components={{ DropdownIndicator }}
                    styles={customSelectStyles}
                  />
                </div>

                {datePreset?.value === "custom" && (
                  <div className="d-flex flex-wrap gap-2 mt-2">
                    <div className="flex-fill">
                      <label className="form-label mb-1 label-1">From</label>
                      <input
                        type="date"
                        className="form-control"
                        min={minDate}
                        max={maxDate}
                        value={customFrom}
                        onChange={(e) => setCustomFrom(e.target.value)}
                      />
                    </div>
                    <div className="flex-fill">
                      <label className="form-label mb-1 label-1">To</label>
                      <input
                        type="date"
                        className="form-control"
                        min={minDate}
                        max={maxDate}
                        value={customTo}
                        onChange={(e) => setCustomTo(e.target.value)}
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* Invoice Status */}
              <div className="col-12 col-lg-auto">
                <label className="form-label mb-1 label-1">Invoice Status</label>
                <div className="po-rs min-220">
                  <Select
                    classNamePrefix="rs"
                    options={INVOICE_STATUS_OPTIONS}
                    value={invoiceSentFilter}
                    onChange={(option) => option && setInvoiceSentFilter(option)}
                    isSearchable
                    components={{ DropdownIndicator }}
                    styles={customSelectStyles}
                  />
                </div>
              </div>

              {/* Order Status */}
              <div className="col-12 col-lg-auto">
                <label className="form-label mb-1 label-1">Order Status</label>
                <div className="po-rs min-220">
                  <Select
                    classNamePrefix="rs"
                    options={orderStatusOptions}
                    value={orderStatusFilter}
                    onChange={(option) => option && setOrderStatusFilter(option)}
                    isSearchable
                    components={{ DropdownIndicator }}
                    styles={customSelectStyles}
                  />
                </div>
              </div>

              {/* Payment Status */}
              <div className="col-12 col-lg-auto">
                <label className="form-label mb-1 label-1">Payment Status</label>
                <div className="po-rs min-220">
                  <Select
                    classNamePrefix="rs"
                    options={PAYMENT_STATUS_OPTIONS}
                    value={paymentStatusFilter}
                    onChange={(option) => option && setPaymentStatusFilter(option)}
                    isSearchable
                    components={{ DropdownIndicator }}
                    styles={customSelectStyles}
                  />
                </div>
              </div>

              {/* Priority */}
              <div className="col-12 col-md-auto">
                <label className="form-label mb-1 label-1">Priority</label>
                <div className="po-rs min-220">
                  <Select
                    classNamePrefix="rs"
                    options={PRIORITY_OPTIONS}
                    value={priorityFilter}
                    onChange={(option) => option && setPriorityFilter(option)}
                    isSearchable
                    components={{ DropdownIndicator }}
                    styles={customSelectStyles}
                  />
                </div>
              </div>

              {/* Actions */}
              <div className="col-12 col-md-auto d-flex justify-content-md-end gap-2 mt-1 mt-md-0">
                <button className="btn btn-primary table-addbutton flex-fill flex-lg-grow-0" onClick={() => {
                  setPagination({ ...pagination, pageIndex: 0 });
                }}>
                  Apply Filters
                </button>

                <button
                  className="btn back-btn surface-btn fw-bold fs-16 flex-fill flex-lg-grow-0"
                  onClick={() => {
                    // Reset all filters to default values
                    setDatePreset(DATE_OPTIONS[3]); // "Last 30 Days" (default)
                    setCustomFrom("");
                    setCustomTo("");
                    setInvoiceSentFilter(INVOICE_STATUS_OPTIONS[0]);
                    setOrderStatusFilter(EMPTY_ORDER_STATUS_OPTION); // "Order Status" (default)
                    setPaymentStatusFilter(PAYMENT_STATUS_OPTIONS[0]); // "Payment Status" (default)
                    setPriorityFilter(PRIORITY_OPTIONS[0]); // "Priority" (default)
                    setGlobalFilter(""); // Clear search
                    setSearchInput(""); // Clear search input
                    setPagination({ pageIndex: 0, pageSize: 10 }); // Reset to first page
                  }}
                >
                  Clear
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="card overflow-hidden production-card box-shadow-datatables shadow-border-datatables">
        {/* Header like screenshot (left title, right count pill) */}
        <div className="align-items-center bg-white border-bottom d-flex justify-content-between px-4 py-4">
          <h5 className="mb-0 ">Removals</h5>
          <span className="badge rounded-pill bg-body-tertiary text-secondary-emphasis px-3 py-2">
            {/* orders */}
          </span>
        </div>
        <hr className="mb-2" style={{ borderTop: "none" }} />


        {/* DESKTOP/TABLET */}
        <div className="rdt-desktop">
          <div
            className="production-scroll"
            style={{ "--rdt-min": "1200px" } as React.CSSProperties}
          >
            <table className="table production-table align-middle mb-0 table-1">
              {showTableLoader ? (
                <DesktopTableLoader table={table} message="Loading removal requests…" variant="dots" />
              ) : (
                <DesktopTableParts
                  table={table}
                  onRowClick={(row) => {
                    const removalId = getRemovalWorkOrderId(row);
                    if (!removalId) return;
                    navigate(`${baseRoute}/jobs/removalWorkorder/${removalId}`);
                  }}
                />
              )}
            </table>
          </div>
        </div>

        {/* MOBILE (≤ 1021px) */}
        <div className="rdt-mobile">
          {showTableLoader ? (
            <MobileCardsLoader message="Loading removal requests…" variant="dots" />
          ) : (
            <MobileCardsOnly
              table={table}
              idColId="order_link"
              titleColId="product_name"
              actionColId="actions"
              onRowClick={(row) => {
                const removalId = getRemovalWorkOrderId(row);
                if (!removalId) return;
                navigate(`${baseRoute}/jobs/removalWorkorder/${removalId}`);
              }}
            />
          )}
        </div>

      </div>
      <DataTableStatus
        loading={showTableLoader}
        isEmpty={table.getRowModel().rows.length === 0}
      >
        <div className="mt-4 mb-4">
          <TablePaginationControls table={table} />
        </div>
      </DataTableStatus>

    </div>
  );
};

export default SignageRemovalRequests;